import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table";
import { MemoizedTable } from "./Table";
import { useTheme } from "@table-library/react-table-library/theme";
import { getTheme } from "@table-library/react-table-library/baseline";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SearchBar from "./SearchBar";
import { BsSearch } from "react-icons/bs";

import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

const DataView = () => {
  const [hashData, setHashData] = useState({ nodes: [] });
  const [searchString, setSearchString] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filterString, setFilterString] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const [isTxData, setIsTxData] = useState(true);
  const [tableData, setTableData] = useState({ nodes: [] });

  useEffect(() => {
    let sP = searchParams.get("search");
    if (sP && sP.length > 0) {
      setSearchString(searchParams.get("search"));
    }
  }, [searchParams]);

  const theme = useTheme([
    getTheme(),
    {
      Table: `
          --data-table-library_grid-template-columns:  20% 14% 20% 15% 21% 10%;
          `,
      HeaderRow: `
                background-color: #171717;
                color: #fff;
                line-height: 1em;
                text-align: center;
                width: 100%;
                text-wrap:wrap;
              `,
      Row: `
                &:nth-of-type(odd) {
                  background-color: #000000;
                }
        
                &:nth-of-type(even) {
                  background-color: #171717;
                }
                &:hover {
                  background-color: #7fccbd;
                  color: #000;

                  a {
                    background-color: #7fccbd;
                    color: #000;
                  }
                }
                color: #7fccbd;
                line-height: 3em;
                text-align: right;
              `,
    },
  ]);

  return (
    <>
      <div className="overlay">
        <h2>This app is only available on a desktop.</h2>
      </div>
      <SearchBar
        setHashData={setHashData}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setSearchString={setSearchString}
        searchString={searchString}
        filterString={filterString}
        setFilterString={setFilterString}
      />
      <div className="mainPage">
        <MemoizedTable
          setTableData={setTableData}
          tableData={tableData}
          setIsTxData={setIsTxData}
          setHashData={setHashData}
          searchString={searchString}
          isLoading={isLoading}
        />
        {tableData.nodes.length > 0 && (
          <div
            className={`rightPane ${
              hashData.nodes.length === 0 ? "centerText" : ""
            }`}
          >
            {hashData.nodes.length > 0 && (
              <Table
                data={hashData}
                theme={theme}
                layout={{ custom: true, horizontalScroll: false }}
              >
                {(tableList) => (
                  <>
                    <Header>
                      <HeaderRow className="align-center">
                        <HeaderCell className="headCell">Tx Hash</HeaderCell>
                        <HeaderCell className="headCell">
                          SC Func. Name
                        </HeaderCell>
                        <HeaderCell className="headCell">
                          <div className="headCell">
                            New Gas Used
                            <Tooltip
                              title="tx gas used after Sirius activation"
                              placement="bottom"
                            >
                              <InfoIcon
                                style={{ fontSize: "20px", paddingLeft: "5px"}}
                              />
                            </Tooltip>
                          </div>
                        </HeaderCell>
                        <HeaderCell>
                          <div className="headCell">
                            Gas Used
                            <Tooltip
                              title="tx gas used before Sirius activation"
                              placement="bottom"
                            >
                              <InfoIcon
                                style={{ fontSize: "20px", paddingLeft: "5px" }}
                              />
                            </Tooltip>
                          </div>
                        </HeaderCell>
                        <HeaderCell>
                          <div className="headCell">
                            Extra Gas Required
                            <Tooltip
                              title="estimated extra gas needed after Sirius activation"
                              placement="bottom"
                            >
                              <InfoIcon
                                style={{ fontSize: "20px", paddingLeft: "5px" }}
                              />
                            </Tooltip>
                          </div>
                        </HeaderCell>
                        <HeaderCell className="explorerLnkColumn"></HeaderCell>
                      </HeaderRow>
                    </Header>

                    <Body>
                      {tableList.map((item, idx) => (
                        <Row key={`${item.tx_hash}-${idx}`} item={item}>
                          <Cell>{item.tx_hash}</Cell>
                          <Cell className="alignLeft">{item.sc_func}</Cell>
                          <Cell>{item.new_gas_used}</Cell>
                          <Cell>{item.gas_used}</Cell>
                          <Cell>{Math.abs(item.extra_est_gas_needed)}</Cell>
                          <Cell className="alignCenter explorerLnkColumn">
                            <a
                              className="explorerLnk"
                              target="_blank"
                              href={`https://explorer.multiversx.com/search/${item.tx_hash}`}
                              rel="noreferrer"
                            >
                              <BsSearch />
                            </a>
                          </Cell>
                        </Row>
                      ))}
                    </Body>
                  </>
                )}
              </Table>
            )}
            {hashData.nodes.length === 0 && isTxData && (
              <h2>Click an address to get tx examples</h2>
            )}
            {!isTxData && <h2>No Transaction data for this address</h2>}
          </div>
        )}
      </div>
    </>
  );
};

export default DataView;
